export interface IAgreementBaseTemplateForm {
  title: string;
  defaultValue: string;
}

export interface IAgreementBaseTemplate extends IAgreementBaseTemplateForm {
  position: number;
  update: boolean;
  mode?: number;
}

export interface IAgreementTemplatBaseResponse extends IAgreementBaseTemplate {}

export interface ITextAgreementTemplate extends IAgreementBaseTemplate {}
export interface ISelectAgreementTemplate extends IAgreementBaseTemplate {
  options: string[];
}

export interface ITextAgreementTemplateForm
  extends IAgreementBaseTemplateForm {}
export interface ISelectAgreementTemplateForm
  extends IAgreementBaseTemplateForm {
  options: string[];
}

export interface ITextAgreementTemplateResponse
  extends IAgreementTemplatBaseResponse {
  id: string;
}
export interface ISelectAgreementTemplateResponse
  extends IAgreementTemplatBaseResponse {
  id: string;
  options: string[];
}

export interface IAgreementTemplatetAggregator {
  textAgreementTemplate: ITextAgreementTemplate | null;
  selectAgreementTemplate: ISelectAgreementTemplate | null;
}

export interface IDistributionSharesForm {
  name: string;
  id: string;
  percent?: number;
  amountPerUnit?: number;
}

export interface IAgreementTemplatetAggregatorForm {
  type: AGREEMENT_TYPE;
  textAgreementTemplate?: ITextAgreementTemplateForm | null;
  selectAgreementTemplate?: ISelectAgreementTemplateForm | null;
  paragraphAgreementTemplate?: ITextAgreementTemplateForm | null;
  distributionTemplateShares?: IDistributionSharesForm | null;
}

export interface IUpdateAgreementTemplate {
  agreementTemplateId: string;
  textAgreementTemplate: ITextAgreementTemplate | null;
  selectAgreementTemplate: ISelectAgreementTemplate | null;
}

export interface IUpdateAgreementTemplateResponse {
  agreementTemplaceId: string;
  position: number;
  title: string;
  agreementType: AGREEMENT_TYPE;
}

export type IAgreementTemplateType =
  | AGREEMENT_TYPE
  | { id: AGREEMENT_TYPE; name: string };

export type IAgreementTemplateResponse = {
  id: string;
  position: number;
  title: string;
  defaultValue: string;
  type: IAgreementTemplateType;
  mode?: number;
} & (
  | { options: null }
  | { options: string[] }
);

export enum AGREEMENT_TYPE {
  unknown = -1,
  text = 1,
  select = 2,
  paragraph = 3,
  shares = 4,
  defaultShare = 5,
}
